"use strict";

require("../../style/index.less");

require("./index.less");


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/lib/icon/style/index.js
// module id = 42
// module chunks = 0